module.exports = __webpack_public_path__ + "static/mckinsey-47e96ccb3cd818f256c2e5f6211e4e90.jpg";